export const LIST_SEARCH_DEBOUNCE_MS = 450;

export const OFFER_STATUS_FILTERS = [
  { value: "", label: "Todos" },
  { value: "in_progress", label: "Em andamento" },
  { value: "accepted", label: "Aceita" },
  { value: "canceled", label: "Cancelada" },
] as const;

export type OfferStatusFilter = (typeof OFFER_STATUS_FILTERS)[number]["value"];

export const BINARY_FILTER_OPTIONS = [
  { value: "", label: "Todos" },
  { value: "1", label: "Sim" },
  { value: "0", label: "Não" },
] as const;

export type BinaryFilterValue = (typeof BINARY_FILTER_OPTIONS)[number]["value"];

export function parseOfferStatusFilter(
  value: string | null | undefined
): OfferStatusFilter {
  if (
    value === "in_progress" ||
    value === "accepted" ||
    value === "canceled"
  ) {
    return value;
  }
  return "";
}

export function parseBinaryFilter(
  value: string | null | undefined
): BinaryFilterValue {
  if (value === "1" || value === "0") return value;
  return "";
}

export function buildListQuery(
  params: Record<string, string | number | null | undefined>
): string {
  const search = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value == null) return;
    const text = String(value).trim();
    if (text === "") return;
    search.set(key, text);
  });

  const query = search.toString();
  return query === "" ? "" : `?${query}`;
}

export function buildPagedListPath(
  basePath: string,
  page: number,
  params: Record<string, string | number | null | undefined>
): string {
  const safePage = Number.isFinite(page) && page > 0 ? Math.floor(page) : 1;
  return `${basePath}/${safePage}${buildListQuery(params)}`;
}

export function truncateText(value: string | null | undefined, maxLength: number): string {
  const text = String(value ?? "").trim();
  if (text === "") return "";
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength).trimEnd()}…`;
}

export function shouldSyncSearchToFirstPage(
  debouncedSearch: string,
  urlSearch: string | null | undefined
): boolean {
  return debouncedSearch !== (urlSearch ?? "").trim();
}
